<template>
  <div class="property-listing card rounded-3"
       :class="border ? 'border' : 'border-0'">

    <div class="listing-img-wrapper p-3">
      <div class="rounded-3 overflow-hidden">
        <img
            :src="item.image"
            class="img-fluid"
            alt="exhibit-image"
            loading="lazy"
        />
      </div>
    </div>

    <div class="listing-caption-wrapper px-3">
      <h4 class="listing-name fw-semibold fs-5 mb-2 mt-3">
        <router-link :to="computedLink">
          {{ item.name }}
        </router-link>
      </h4>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue"
import {useI18n} from "vue-i18n"
import { defineProps} from 'vue';
const props = defineProps({
  item: Object,
  border: Boolean,
  routeName: String,
  basePath: String
})

const {locale} = useI18n()
const computedLink = computed(() => {

  if (props.routeName) {
    return {
      name: props.routeName,
      params: {locale: locale.value},
      query: {country: props.item.id}
    }
  }

  if (props.basePath) {
    return `/${locale.value}${props.basePath}?country=${encodeURIComponent(props.item.id)}`
  }

  return {
    path: `/${locale.value}/exhibits/search`,
    query: {country: props.item.id}
  }

})
</script>